module.exports = __webpack_public_path__ + "static/img/7.ad9013a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/7.png
// module id = mMqC
// module chunks = 1